<template>
  <a-modal
    ref="createModal"
    title="新增物料类别分配"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 900, y: 260 }"
    >
      <!-- 物料编码 -->
      <span slot="itemCodeTitle">
        <i class="toRequired">*</i>物料编码
      </span>
      <template slot="itemCode" slot-scope="text, record">
        <global-select
          :value.sync="record.itemCode"
          selectType="selectSearch"
          requestApi="/mdm/itemApportion/itemMessage"
          :selectItem="{ value: 'itemCode', label: 'itemCode' }"
          searchParam="itemCode"
          @change="(val, list) => itemCodeOnChange(val, list, record)"
        />
      </template>
      <!-- 物料名称 -->
      <template slot="itemName" slot-scope="text, record">
        <a-input v-model="record.itemName" disabled />
      </template>
      <!-- 类别 -->
      <template slot="categoryCode" slot-scope="text, record">
        <a-cascader
          v-model="record.categoryCode"
          :field-names="{ label: 'name', value: 'code', children: 'segmentVOs' }"
          :options="categoryDescList"
          expand-trigger="hover"
          placeholder=""
        />
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiItemApportionAdd } from '@/api/mdm/matter/material-category'
// 表单字段
export default {
  props: {
    categorySetId: {
      type: String,
      default: ""
    },
    categoryDescList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '物料编码',
          width: 160,
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode', title: "itemCodeTitle" }
        },
        {
          title: '物料名称',
          width: 160,
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' }
        },
        {
          title: '规格描述',
          dataIndex: 'description',
          width: 150,
          ellipsis: true
        },
        {
          title: '类别',
          dataIndex: 'categoryCode',
          scopedSlots: { customRender: 'categoryCode' },
          width: 250
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: []
    }
  },
  created () {},
  methods: {
    // 物料编码
    itemCodeOnChange (val, list, record) {
      record.description = this.$getFlagName(list, val, "itemCode", "specification")
      record.attributeId = this.$getFlagName(list, val, "itemCode", "itemCode")
      record.itemName = this.$getFlagName(list, val, "itemCode", "itemName")
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        itemCode: "",
        itemName: "",
        description: "",
        categoryCode: [],
        attributeId: "",
        categorySetId: this.categorySetId,
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      const tableList = JSON.parse(JSON.stringify(this.typeList))
      let flag = false
      for (let i = 0; i < tableList.length; i++) {
        if (!tableList[i].itemCode || !tableList[i].categoryCode) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        tableList[i].categoryCode = tableList[i].categoryCode.join(".")
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiItemApportionAdd(tableList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-cascader-input{
  width: 240px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input {
  width: 150px;
}
</style>
